import { PorApi } from './generated-src';
import { getAppSetting } from '../config/AppSettings';
import { Configuration } from "./generated-src/configuration";

export default function () {
  const apiBasePath = `${getAppSetting('apiUrl')}/jwt`;
  return new PorApi(new Configuration({ basePath: apiBasePath }));
}
